import { defineMessages, MessageDescriptor } from 'react-intl';

export const msgs = defineMessages({
  learnWithMemriseAnswerPart4: {
    id: 'seo_course_faq_learn_with_memrise_answer_part4',
  },
  learnWithMemriseAnswerPart5: {
    id: 'seo_course_faq_learn_with_memrise_answer_part5',
  },

  whereStartAnswerPart1: { id: 'seo_course_faq_where_start_answer_part1' },
  whereStartAnswerPart6: { id: 'seo_course_faq_where_start_answer_part6' },
  whereStartAnswerPart7: { id: 'seo_course_faq_where_start_answer_part7' },
  whereStartAnswerPart9: { id: 'seo_course_faq_where_start_answer_part9' },

  howMuchTimeAnswerPart1: {
    id: 'seo_course_faq_how_much_time_answer_part1',
  },
  howMuchTimeAnswerPart2: {
    id: 'seo_course_faq_how_much_time_answer_part2_v2',
  },
  howMuchTimeAnswerPart3: {
    id: 'seo_course_faq_how_much_time_answer_part3',
  },

  myLevelAnswerPart1: { id: 'seo_course_faq_my_level_answer_part1' },
  myLevelAnswerPart2: { id: 'seo_course_faq_my_level_answer_part2' },
  myLevelAnswerPart3: { id: 'seo_course_faq_my_level_answer_part3_v2' },
  myLevelAnswerPart4: { id: 'seo_course_faq_my_level_answer_part4_v2' },
  myLevelAnswerPart5: { id: 'seo_course_faq_my_level_answer_part5' },

  certificateAnswerPart1: {
    id: 'seo_course_faq_certificate_answer_part1',
  },
  certificateAnswerPart2: {
    id: 'seo_course_faq_certificate_answer_part2',
  },

  difficultToLearnAnswerPart1: {
    id: 'seo_course_faq_difficult_to_learn_answer_part1',
  },
  difficultToLearnAnswerPart2: {
    id: 'seo_course_faq_difficult_to_learn_answer_part2',
  },
});

type LocalizedMessages = {
  whyLearnQuestion?: MessageDescriptor;
  whyLearnAnswer?: MessageDescriptor;

  learnWithMemriseQuestion: MessageDescriptor;
  learnWithMemriseAnswerPart1: MessageDescriptor;
  learnWithMemriseAnswerPart2: MessageDescriptor;
  learnWithMemriseAnswerPart3: MessageDescriptor;

  whereStartQuestion: MessageDescriptor;
  whereStartAnswerPart2: MessageDescriptor;
  whereStartAnswerPart3: MessageDescriptor;
  whereStartAnswerPart4: MessageDescriptor;
  whereStartAnswerPart5: MessageDescriptor;
  whereStartAnswerPart8: MessageDescriptor;

  howMuchTimeQuestion: MessageDescriptor;

  myLevelQuestion: MessageDescriptor;

  certificateQuestion: MessageDescriptor;

  difficultToLearnQuestion: MessageDescriptor;
  difficultToLearnAnswerPart3: MessageDescriptor;
};

export const ar: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_ar',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_ar',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_ar',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_ar',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_ar' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_ar',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_ar',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_ar',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_ar',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_ar',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_ar' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_ar' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_ar' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_ar',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_ar',
  },
});

export const da: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_da',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_da',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_da',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_da',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_da' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_da',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_da',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_da',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_da',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_da',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_da' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_da' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_da' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_da',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_da',
  },
});

export const de: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_de' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_de' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_de',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_de',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_de',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_de',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_de' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_de',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_de',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_de',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_de',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_de',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_de' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_de' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_de' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_de',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_de',
  },
});

export const el: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_el',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_el',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_el',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_el',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_el' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_el',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_el',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_el',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_el',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_el',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_el' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_el' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_el' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_el',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_el',
  },
});

export const en: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_en' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_en' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_en',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_en',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_en',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_en',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_en' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_en',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_en',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_en',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_en',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_en',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_en' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_en' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_en' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_en',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_en',
  },
});

export const en_us: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_en-us' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_en-us' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_en',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_en',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_en',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_en',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_en' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_en',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_en',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_en',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_en',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_en',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_en' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_en' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_en' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_en',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_en',
  },
});

export const es: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_es' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_es' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_es',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_es',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_es',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_es',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_es' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_es',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_es',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_es',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_es',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_es',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_es' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_es' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_es' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_es',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_es',
  },
});

export const es_mx: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_es_mx' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_es_mx' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_es',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_es',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_es',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_es',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_es_mx' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_es_mx',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_es_mx',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_es_mx',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_es_mx',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_es_mx',
  },

  howMuchTimeQuestion: {
    id: 'seo_course_faq_how_much_time_question_es_mx',
  },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_es_mx' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_es_mx' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_es_mx',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_es_mx',
  },
});

export const fa: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_fa',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_fa',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_fa',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_fa',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_fa' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_fa',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_fa',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_fa',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_fa',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_fa',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_fa' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_fa' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_fa' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_fa',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_fa',
  },
});

export const fr: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_fr' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_fr' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_fr',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_fr',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_fr',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_fr',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_fr' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_fr',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_fr',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_fr',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_fr',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_fr',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_fr' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_fr' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_fr' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_fr',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_fr',
  },
});

export const he: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_he',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_he',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_he',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_he',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_he' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_he',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_he',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_he',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_he',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_he',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_he' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_he' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_he' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_he',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_he',
  },
});

export const hi: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_hi',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_hi',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_hi',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_hi',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_hi' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_hi',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_hi',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_hi',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_hi',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_hi',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_hi' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_hi' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_hi' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_hi',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_hi',
  },
});

export const id: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_id',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_id',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_id',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_id',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_id' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_id',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_id',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_id',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_id',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_id',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_id' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_id' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_id' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_id',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_id',
  },
});

export const is: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_is',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_is',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_is',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_is',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_is' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_is',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_is',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_is',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_is',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_is',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_is' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_is' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_is' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_is',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_is',
  },
});

export const it: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_it' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_it' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_it',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_it',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_it',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_it',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_it' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_it',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_it',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_it',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_it',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_it',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_it' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_it' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_it' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_it',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_it',
  },
});

export const jp_full: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_jp_full' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_jp_full' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_jp_full',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_jp_full',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_jp_full',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_jp_full',
  },

  whereStartQuestion: {
    id: 'seo_course_faq_where_start_question_jp_full',
  },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_jp_full',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_jp_full',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_jp_full',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_jp_full',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_jp_full',
  },

  howMuchTimeQuestion: {
    id: 'seo_course_faq_how_much_time_question_jp_full',
  },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_jp_full' },

  certificateQuestion: {
    id: 'seo_course_faq_certificate_question_jp_full',
  },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_jp_full',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_jp_full',
  },
});

export const jp_romaji: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_jp_full',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_jp_full',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_jp_full',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_jp_full',
  },

  whereStartQuestion: {
    id: 'seo_course_faq_where_start_question_jp_romaji',
  },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_jp_romaji',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_jp_romaji',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_jp_romaji',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_jp_romaji',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_jp_romaji',
  },

  howMuchTimeQuestion: {
    id: 'seo_course_faq_how_much_time_question_jp_romaji',
  },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_jp_romaji' },

  certificateQuestion: {
    id: 'seo_course_faq_certificate_question_jp_romaji',
  },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_jp_romaji',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_jp_romaji',
  },
});

export const ko: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_ko' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_ko' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_ko',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_ko',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_ko',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_ko',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_ko' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_ko',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_ko',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_ko',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_ko',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_ko',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_ko' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_ko' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_ko' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_ko',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_ko',
  },
});

export const mn: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_mn',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_mn',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_mn',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_mn',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_mn' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_mn',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_mn',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_mn',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_mn',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_mn',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_mn' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_mn' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_mn' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_mn',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_mn',
  },
});

export const nl: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_nl',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_nl',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_nl',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_nl',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_nl' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_nl',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_nl',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_nl',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_nl',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_nl',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_nl' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_nl' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_nl' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_nl',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_nl',
  },
});

export const no: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_no',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_no',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_no',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_no',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_no' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_no',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_no',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_no',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_no',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_no',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_no' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_no' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_no' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_no',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_no',
  },
});

export const pl: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_pl',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_pl',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_pl',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_pl',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_pl' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_pl',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_pl',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_pl',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_pl',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_pl',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_pl' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_pl' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_pl' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_pl',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_pl',
  },
});

export const pt: LocalizedMessages = defineMessages({
  whyLearnQuestion: { id: 'special_seo_copy_language_title_pt' },
  whyLearnAnswer: { id: 'special_seo_copy_language_description_pt' },

  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_pt',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_pt',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_pt',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_pt',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_pt' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_pt',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_pt',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_pt',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_pt',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_pt',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_pt' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_pt' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_pt' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_pt',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_pt',
  },
});

export const pt_br: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_pt',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_pt',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_pt',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_pt',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_pt_br' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_pt_br',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_pt_br',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_pt_br',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_pt_br',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_pt_br',
  },

  howMuchTimeQuestion: {
    id: 'seo_course_faq_how_much_time_question_pt_br',
  },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_pt_br' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_pt_br' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_pt_br',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_pt_br',
  },
});

export const ru: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_ru',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_ru',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_ru',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_ru',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_ru' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_ru',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_ru',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_ru',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_ru',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_ru',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_ru' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_ru' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_ru' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_ru',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_ru',
  },
});

export const sl: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_sl',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_sl',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_sl',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_sl',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_sl' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_sl',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_sl',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_sl',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_sl',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_sl',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_sl' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_sl' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_sl' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_sl',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_sl',
  },
});

export const sv: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_sv',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_sv',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_sv',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_sv',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_sv' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_sv',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_sv',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_sv',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_sv',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_sv',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_sv' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_sv' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_sv' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_sv',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_sv',
  },
});

export const sw: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_sw',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_sw',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_sw',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_sw',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_sw' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_sw',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_sw',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_sw',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_sw',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_sw',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_sw' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_sw' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_sw' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_sw',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_sw',
  },
});

export const th: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_th',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_th',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_th',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_th',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_th' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_th',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_th',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_th',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_th',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_th',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_th' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_th' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_th' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_th',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_th',
  },
});

export const tr: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_tr',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_tr',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_tr',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_tr',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_tr' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_tr',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_tr',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_tr',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_tr',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_tr',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_tr' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_tr' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_tr' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_tr',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_tr',
  },
});

export const uk: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_uk',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_uk',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_uk',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_uk',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_uk' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_uk',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_uk',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_uk',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_uk',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_uk',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_uk' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_uk' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_uk' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_uk',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_uk',
  },
});

export const yo: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_yo',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_yo',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_yo',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_yo',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_yo' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_yo',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_yo',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_yo',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_yo',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_yo',
  },

  howMuchTimeQuestion: { id: 'seo_course_faq_how_much_time_question_yo' },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_yo' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_yo' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_yo',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_yo',
  },
});

export const zh_cn: LocalizedMessages = defineMessages({
  learnWithMemriseQuestion: {
    id: 'seo_course_faq_learn_with_memrise_question_zh_cn',
  },
  learnWithMemriseAnswerPart1: {
    id: 'seo_course_faq_learn_with_memrise_answer_part1_zh_cn',
  },
  learnWithMemriseAnswerPart2: {
    id: 'seo_course_faq_learn_with_memrise_answer_part2_zh_cn',
  },
  learnWithMemriseAnswerPart3: {
    id: 'seo_course_faq_learn_with_memrise_answer_part3_zh_cn',
  },

  whereStartQuestion: { id: 'seo_course_faq_where_start_question_zh_cn' },
  whereStartAnswerPart2: {
    id: 'seo_course_faq_where_start_answer_part2_zh_cn',
  },
  whereStartAnswerPart3: {
    id: 'seo_course_faq_where_start_answer_part3_zh_cn',
  },
  whereStartAnswerPart4: {
    id: 'seo_course_faq_where_start_answer_part4_zh_cn',
  },
  whereStartAnswerPart5: {
    id: 'seo_course_faq_where_start_answer_part5_zh_cn',
  },
  whereStartAnswerPart8: {
    id: 'seo_course_faq_where_start_answer_part8_zh_cn',
  },

  howMuchTimeQuestion: {
    id: 'seo_course_faq_how_much_time_question_zh_cn',
  },

  myLevelQuestion: { id: 'seo_course_faq_my_level_question_zh_cn' },

  certificateQuestion: { id: 'seo_course_faq_certificate_question_zh_cn' },

  difficultToLearnQuestion: {
    id: 'seo_course_faq_difficult_to_learn_question_zh_cn',
  },
  difficultToLearnAnswerPart3: {
    id: 'seo_course_faq_difficult_to_learn_answer_part3_zh_cn',
  },
});
